export default __webpack_public_path__ + "media/images/mailer/icon_grade-a08de46d1039eaed9f037efb5923435f.png";